module.exports = __webpack_public_path__ + "static/media/energy.fb084e1e.jpg";